import { Box, IconButton, Tooltip } from '@mui/material';
import { Eye, EyeOff } from 'lucide-react';
import { FormattedMessage } from 'react-intl';
import { useRecoilState } from 'recoil';
import { doseVisibilityState } from '~/state/atoms/dose/doseAtoms';
import { environmentState } from '~/state/atoms/engineAtoms';

const DoseVisibilityToggle = () => {
    const [environment] = useRecoilState(environmentState);
    const [doseVisibility, setDoseVisibility] =
        useRecoilState(doseVisibilityState);

    const toggleDoseVisibility = (): void => {
        if (environment && doseVisibility !== undefined) {
            setDoseVisibility(!doseVisibility);
            environment.updateDoseVisibility(!doseVisibility);
        }
    };

    return (
        <Box>
            <Tooltip
                title={
                    doseVisibility ? (
                        <FormattedMessage id="hideDose" />
                    ) : (
                        <FormattedMessage id="showDose" />
                    )
                }
            >
                <IconButton
                    color="primary"
                    size="small"
                    aria-controls="image-picker-menu"
                    aria-haspopup="true"
                    data-testid="dose-visibility-toggle"
                    onClick={toggleDoseVisibility}
                    sx={{
                        p: 1,
                        backgroundColor: doseVisibility
                            ? 'inherit'
                            : 'rgba(0,165,185,0.08)',
                    }}
                >
                    {doseVisibility ? (
                        <Eye size={12} aria-label="display-dose-toggle-eye" />
                    ) : (
                        <EyeOff
                            size={12}
                            aria-label="display-dose-toggle-eyeoff"
                        />
                    )}
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default DoseVisibilityToggle;
